import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormSaveResponse, ListOption } from '../../../../modules/tcm-core.module';
import { BroadCastEvents } from '../../../../common/broad-cast-events.enum';
import { NoteTypeEnum } from '../../../../models/enums';
import { NoteFormRequest, NoteFormResponse } from '../../../../models/notes';
import { BaseSecureDetails } from '../../../../modules/tcm-common';
import { SecureBaseComponentContext } from '../../../../modules/tcm-common/services/secure-base-component-context.service';
import { AppointmentDataService } from '../../../../services/appointment-data.service';
import { ClaimService } from '../../../../services/claim.service';
import { ListOptionService } from '../../../../services/list-option.service';
import { PatientDataService } from '../../../../services/patient-data.service';
import { SalesOrderDataService } from '../../../../services/sales-order-data.service';
import { UserDataService, WorkQueueDataService, UserClinicService } from '../../../../services';
import { UserOptionWithUserInfo } from '../../../../models/users';
import { NoteDetailFormSaveResponse } from '../../../../models/notes/note-detail-form-save-response';


@Component({
    selector: 'note-details',
    templateUrl: './note-details.component.html',
    styleUrls: ['./note-details.component.scss'],
    standalone: false
})
export class NoteDetailsComponent extends BaseSecureDetails<NoteFormRequest, NoteFormResponse, NoteDetailFormSaveResponse> {

  noteStatusOptions: ListOption<number>[];
  noteTypeOptions: ListOption<number>[];
  communicationSourceOptions: ListOption<number>[];
  isReadOnlyType: boolean = false;
  isReadOnlyNote: boolean = false;
  isReadOnlyLinkedTo: boolean = false;
  NoteTypeEnum = NoteTypeEnum;

  constructor(protected override componentContext: SecureBaseComponentContext,
    protected override route: ActivatedRoute,
    private patientDataService: PatientDataService,
    private salesOrderDataService: SalesOrderDataService,
    private claimDataService: ClaimService,
    private userDataService: UserDataService,
    private userClinicService: UserClinicService,
    private workQueueDataService: WorkQueueDataService,
    private appointmentDataService: AppointmentDataService,
    private listOptionService: ListOptionService) {
    super(componentContext, route);
    this.actionName = 'Notes/NoteDetails';
    this.noteStatusOptions = this.listOptionService.getNoteStatusOptions();
    this.noteTypeOptions = this.listOptionService.getNoteTypeOptions();
    this.communicationSourceOptions = this.listOptionService.getCommunicationSourceOptions();
  }

  getLinkedToOptionsFunc = (query: string, cancellationToken: Promise<any>): Promise<ListOption<number>[]> => {

    switch (this.viewModel.form.type) {
      case NoteTypeEnum.Patient: {
        return this.patientDataService.getPatientOptionsAsync(query, cancellationToken);
      }
      case NoteTypeEnum.Appointment: {
        return this.appointmentDataService.getOptionsForNoteAsync(query, cancellationToken);
      }
      case NoteTypeEnum.Claim: {
        return this.claimDataService.getOptionsForNoteAsync(query, cancellationToken);
      }
      case NoteTypeEnum.SalesOrder: {
        return this.salesOrderDataService.getOptionsForNoteAsync(query, cancellationToken);
      }
    }
    return new Promise<ListOption<number>[]>(resolve => resolve(null));;
  }

  clearLinkedTo($event) {
    this.viewModel.form.typeKeyId = null;
    this.viewModel.linkedToInitOptions = [];
  }

  getUserOptionsFunc = (query: string, cancellationToken: Promise<any>): Promise<UserOptionWithUserInfo[]> => {
    return this.userDataService.getUserOptionsWithUserInfoAsync(query, cancellationToken);
  }

  async assignedUserChanged(userId: number) {
    this.viewModel.workQueueOptions =
      await this.workQueueDataService.getWorkQueueOptionsForUserAsync(null, userId, this.componentCancellationTokenSource.promise());

    if (!this.viewModel.workQueueOptions.find(x => x.value == this.viewModel.form.workQueueId)) {
      this.viewModel.form.workQueueId = null;
    }
  }

  protected override checkAdditionalCanEditRules() {
    return !this.viewModel || (this.viewModel.isUserClinic && this.viewModel.isPatientActive);
  }

  protected override onProcessSaveSuccess() {
    this.ngForm?.form.markAsPristine();
    this.componentContext.broadcastService.next({ name: BroadCastEvents.NoteChanged, args: this.formSaveResponse });
    this.componentContext.broadcastService.next({ name: BroadCastEvents.WorkQueueTouched });
  }

  protected override onViewModelChanged() {
    super.onViewModelChanged();

    if (this.viewModel.form.id) {
      this.isReadOnlyType = true;
      this.isReadOnlyNote = true;
    }

    if (this.requestModel.type) {
      this.isReadOnlyLinkedTo = true;
      this.isReadOnlyType = true;
    }

    this.viewModel.form.userStickyClinicId = this.userClinicService.clinicId;
  }

  override async back(skipCheck?: boolean) {
    super.back(this.ngForm.pristine);
  }

  next() {
    this.requestModel.id = this.viewModel.form.nextId;
    this.refresh();
  }

  previous() {
    this.requestModel.id = this.viewModel.form.previousId;
    this.refresh();
  }

  protected override buildRequestModelFromFormSaveResponse(saveResponse: FormSaveResponse) {
    return { id: saveResponse.id, patientId: this.requestModel.patientId,  type: this.requestModel.type, typeKeyId: this.requestModel.typeKeyId
    } as NoteFormRequest;
  }

  disablePrevious() {
    if (!this.viewModel) {
      return true;
    }

    return this.isNull(this.viewModel.form.previousId) ? true : false;
  }

  disableNext() {
    if (!this.viewModel) {
      return true;
    }

    return this.isNull(this.viewModel.form.nextId) ? true : false;
  }
  
  isNull(value: number) {
      return value === null
  }

}

